import React from 'react';
import { MobxComponent } from "../../../mobx/components";
import { inject, observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { IconSettings, IconClose, IconDelete, IconWrapperRounded, IconKiosk, IconPickup, IconDelivery, IconDineIn, IconArrowForward, IconKioskCloud, IconCloudWrapper, IconCloud } from "./icons";
import { ColorPicker, Switch } from "@lib/components";
import { HeaderTitleWrapper, MenuItem, QuickSettingsContainer, QuickSettingsHeaderWrapper, QuickSettingsBodyWrapper, QuickSettingsFooterWrapper, QuickSettingsButton, QuickSettingsItemsContainer, QuickSettingsItemsWrapper, QuickSettingsItemWrapper, ButtonV2, MenuColorHeaderWrapper, MenuColorHeaderTitleWrapper, MenuColorDescription, MenuColorBodyWrapper, MenuColorFormGroup, MenuColorLabel, MenuColorColorPickerWrapper, MenuColorColorPickerText, MenuColorPresetsList, MenuColorPresetsListItem, MenuColorPresetsListItemContent, MenuColorFooterWrapper, MenuToggleContainer, MenuToggleText, MenuServiceTypeContainer, MenuServiceTypeItem, MenuLineSeparator, MenuPublishPlatformContainer, MenuPublishPlatFormItem, MenuPublishPlatFormItemHeader, MenuPublishPlatFormItemHeaderLabel, MenuStatusAlert, MenuStatusAlertText, MenuStatusLabelAvailable, MenuStatusServiceList, MenuStatusServiceListItem, MenuStatusServiceListRow, MenuStatusShowSettingsContainer, MenuStatusShowSettingsText } from "./layout.c";
import { CoreUtils } from '@lib/common';
import { IconKioskWrapper } from '../../ui/restaurant/views/menus-v2/item-v2';


interface Props extends WithTranslation {
    show?: boolean;
    onHide?: () => void;
    onSave: (color: string) => void;
    onShowSettings?: () => void;
    title?: string;
    value?: string;
    conditions?: any;
    type?: 'menu' | 'category' | 'item';
    categoryCount?: number;
    itemCount?: number;
}
interface State {
    color: string;
}

@inject("store") @observer
class MenuPreVisibilityClass extends MobxComponent<Props, State> {
    constructor(props: Props) {
		super(props);
		this.state = {
            color: props.value || '#000000'
        };
	}
   
    render() {
        const { store, t} = this.injected;
        const { show, onHide, onSave, title, onShowSettings, conditions, type, categoryCount, itemCount } = this.props;
        const { color } = this.state;
        console.log('conditions', conditions);
        return (
        <QuickSettingsContainer className={show ? 'active': ''}>
            <MenuColorHeaderWrapper>
                <MenuColorHeaderTitleWrapper>
                    {title || 'Acme Pizza'}
                </MenuColorHeaderTitleWrapper>
                <MenuItem onClick={onHide}><IconClose /></MenuItem>
            </MenuColorHeaderWrapper>
            <MenuColorBodyWrapper style={{minHeight: '50vh', overflowY:'scroll'}}>
                <MenuStatusAlert>
                    {conditions?.pos?.enabled && conditions.online?.enabled && ( <>
                        <IconKioskCloud />
                         <MenuStatusAlertText>This menu is active on both POS/Online </MenuStatusAlertText>
                        </>
                    )}
                    {conditions?.pos?.enabled && !conditions?.online?.enabled && <>
                    <IconKioskWrapper>
                        <IconKiosk />
                    </IconKioskWrapper> 
                     <MenuStatusAlertText>This menu is active POS only</MenuStatusAlertText>
                    </>}
                    {!conditions?.pos?.enabled && conditions?.online?.enabled && <>
                    <IconCloudWrapper>
                        <IconCloud />
                    </IconCloudWrapper>
                    <MenuStatusAlertText>This menu is active Online only</MenuStatusAlertText>
                    </>}
                    {/* <IconKioskWrapper>
                        <IconKiosk />
                    </IconKioskWrapper> */}
                   
                </MenuStatusAlert>

                {type !== 'item' && <MenuStatusLabelAvailable> {categoryCount} categor{categoryCount === 1 ? 'y' : 'ies'} and  {itemCount} item{itemCount === 1 ? '' : 's'} {itemCount === 1 ? 'is' : 'are'} available for</MenuStatusLabelAvailable>}
               <MenuStatusServiceList>
                    {conditions?.pos?.enabled && conditions.online?.enabled && ( 
                    <MenuStatusServiceListRow>
                        {
                        //@ts-ignore
                        Array.from(new Set((conditions?.pos?.services || []).concat(conditions?.online?.services || [])) as string[]).map((service: string) => (
                            <MenuStatusServiceListItem key={service}>{
                                service === 'dine_in' ? <IconDineIn /> : service === 'pickup' ? <IconPickup /> : service === 'delivery' ? <IconDelivery /> : <IconKiosk />
                            } {service.charAt(0).toUpperCase() + service.slice(1).replace('_', '-')}</MenuStatusServiceListItem>  
                        ))}
                    </MenuStatusServiceListRow>
                    )}
                    {conditions?.pos?.enabled && !conditions.online?.enabled && (
                        <MenuStatusServiceListRow>
                            {conditions?.pos?.services?.map((service: string) => (
                                <MenuStatusServiceListItem key={service}>
                                    {service === 'dine_in' ? <IconDineIn /> : service === 'pickup' ? <IconPickup /> : service === 'delivery' ? <IconDelivery /> : <IconKiosk />
                                    } {service.charAt(0).toUpperCase() + service.slice(1).replace('_', '-')}</MenuStatusServiceListItem>
                            ))}
                        </MenuStatusServiceListRow>
                    )}
                    {!conditions?.pos?.enabled && conditions?.online?.enabled && (
                        <MenuStatusServiceListRow>
                            {conditions?.online?.services?.map((service: string) => (
                                <MenuStatusServiceListItem key={service}>
                                    {service === 'dine_in' ? <IconDineIn /> : service === 'pickup' ? <IconPickup /> : service === 'delivery' ? <IconDelivery /> : <IconCloud />
                                    } {service.charAt(0).toUpperCase() + service.slice(1).replace('_', '-')}</MenuStatusServiceListItem>
                            ))}
                        </MenuStatusServiceListRow>
                    )}
               </MenuStatusServiceList>
               <MenuStatusShowSettingsContainer
                    onClick={onShowSettings}>
                    <MenuStatusShowSettingsText>Show settings</MenuStatusShowSettingsText>
                    <IconArrowForward />
               </MenuStatusShowSettingsContainer>
            </MenuColorBodyWrapper>
        </QuickSettingsContainer>
        )
    }
}
export const MenuPreVisibility = withTranslation()(MenuPreVisibilityClass);
